// extracted by mini-css-extract-plugin
export var arrow = "Home-module--arrow--9K322";
export var bottom = "Home-module--bottom--BEG1c";
export var intro = "Home-module--intro--2Xg6A";
export var linkTiles = "Home-module--linkTiles--XSi0g";
export var portrait = "Home-module--portrait--QANNf";
export var text = "Home-module--text--YrCu5";
export var title = "Home-module--title--hhukN";